import React from "react";

import { Stack } from "@mui/material";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";
import { pluralize } from "@src/utils/pluralize";

import styles from "./DoNotSellModal.module.css";

export type FooterProps = {
  isMutating: boolean;
  onConfirm: () => void;
  onCloseModal: () => void;
  numberChanges: number;
};

const Footer = ({
  isMutating,
  onConfirm,
  onCloseModal,
  numberChanges,
}: FooterProps) => {
  return (
    <div className={styles.footerContainer}>
      <Stack direction={"row"} spacing={2}>
        <Text variant="body" style={{ alignContent: "center" }}>
          {numberChanges === 0
            ? "No unsaved changes"
            : `${pluralize(numberChanges, "Unsaved change", true)}`}
        </Text>
      </Stack>
      <Stack direction={"row"} spacing={2}>
        <Button
          disabled={isMutating}
          variant={"text"}
          buttonType={"secondary"}
          text={"Cancel"}
          onClick={onCloseModal}
        />
        <Button
          disabled={isMutating || numberChanges === 0}
          variant={"contained"}
          buttonType={"primary"}
          text={"Save"}
          onClick={onConfirm}
        />
      </Stack>
    </div>
  );
};

export const FooterLoadingState = () => (
  <div className={styles.footerContainer}>
    <Stack direction={"row"} spacing={2}>
      <Skeleton width="130px" height="20px" />
    </Stack>

    <Stack direction={"row"} spacing={2}>
      <Skeleton width="72px" height="32px" />
      <Skeleton width="72px" height="32px" />
    </Stack>
  </div>
);

export default Footer;
